<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card class="pa-3">
            <v-card-title>
                <h2 class="title">Edit Training</h2>
            </v-card-title>

            <div v-if="loading" class="my-3 px-6">
                <v-progress-linear
                        :indeterminate="loading"
                        :class="{ 'no-opacity': !loading }"
                        style="height: 2px;"
                ></v-progress-linear>
            </div>
            <template v-else>
                <v-card-text class="mt-5">
                    <div>
                        <div class="px-2">
                            <v-autocomplete
                                    :items="trainingCategories"
                                    name="category_ids"
                                    id="category_ids"
                                    label="Training Topics"
                                    item-text="name"
                                    item-value="id"
                                    multiple
                                    class="mb-3"
                                    v-model="preparedData.category_ids"
                                    placeholder="Please Select"
                                    :error-messages="errors($v.preparedData.category_ids) || server_errors.category_ids"
                                    @focus="resetServerValidation"
                            ></v-autocomplete>
                            <v-menu
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="preparedData.date_from"
                                        label="Start date"
                                        class="mb-3"
                                        placeholder="Please Select"
                                        :error-messages="errors($v.preparedData.date_from) || server_errors.date_from"
                                        @focus="resetServerValidation"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="preparedData.date_from" @input="menu1 = false"></v-date-picker>
                            </v-menu>
                            <v-menu
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="preparedData.date_to"
                                        label="End date"
                                        class="mb-3"
                                        placeholder="Please Select"
                                        :error-messages="errors($v.preparedData.date_to) || server_errors.date_to"
                                        @focus="resetServerValidation"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="preparedData.date_to" @input="menu2 = false"></v-date-picker>
                            </v-menu>

                            <v-text-field
                                v-model="preparedData.title"
                                name="title"
                                id="title"
                                label="Title"
                                class="mb-3"
                                placeholder="Please Enter"
                                :error-messages="errors($v.preparedData.title) || server_errors.title"
                                @focus="resetServerValidation"
                            ></v-text-field>
                            <v-textarea
                                v-model="preparedData.description"
                                name="description"
                                id="description"
                                class="mb-3"
                                label="Description"
                                placeholder="Please Enter"
                                :error-messages="errors($v.preparedData.description) || server_errors.description"
                                @focus="resetServerValidation"
                            ></v-textarea>
                            <v-text-field
                                v-model="preparedData.contact_email"
                                label="Contact Email"
                                class="mb-3"
                                placeholder="Please Enter"
                                :error-messages="errors($v.preparedData.contact_email) || server_errors.contact_email"
                                @focus="resetServerValidation"
                            ></v-text-field>
                            <v-text-field
                                v-model="preparedData.contact_phone"
                                label="Contact Phone"
                                class="mb-3"
                                mask="phone"
                                placeholder="Please Enter"
                                :error-messages="errors($v.preparedData.contact_phone) || server_errors.contact_phone"
                                @focus="resetServerValidation"
                            ></v-text-field>
                            <v-checkbox
                                v-model="preparedData.not_have_location"
                                label="This event does not have a physical location and it's online training only"
                            ></v-checkbox>
                            <template v-if="!preparedData.not_have_location">
                                <v-autocomplete
                                        :items="countries"
                                        label="Country"
                                        item-text="name"
                                        item-value="id"
                                        class="mb-3"
                                        v-model="preparedData.country_id"
                                        @change="checkState"
                                        placeholder="Please Select"
                                        :error-messages="errors($v.preparedData.country_id) || server_errors.country_id"
                                        @focus="resetServerValidation"
                                ></v-autocomplete>
                                <v-autocomplete
                                    :items="filteredStates"
                                    name="state_id"
                                    id="state_id"
                                    label="State"
                                    item-text="name"
                                    item-value="id"
                                    class="mb-3"
                                    v-model="preparedData.state_id"
                                    placeholder="Please Select"
                                    :error-messages="errors($v.preparedData.state_id) || server_errors.state_id"
                                    @focus="resetServerValidation"
                                ></v-autocomplete>
                                <v-text-field
                                    v-model="preparedData.city"
                                    name="city"
                                    id="city"
                                    class="mb-3"
                                    label="City"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.city) || server_errors.city"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                                <v-text-field
                                    v-model="preparedData.address"
                                    name="address"
                                    id="address"
                                    class="mb-3"
                                    label="Address"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.address) || server_errors.address"
                                    @focus="resetServerValidation"
                                ></v-text-field>
                            </template>
                            <template v-else>
                                <v-text-field
                                    v-model="preparedData.website"
                                    label="Website URL"
                                    class="mb-3"
                                    placeholder="Please Enter"
                                    :error-messages="errors($v.preparedData.website) || server_errors.website"
                                    @focus="resetServerValidation"
                                >
                                    <v-tooltip slot="append" top class="mb-2">
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" class="mb-1 pointer">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <div style="max-width: 250px;">Provide a URL that will take users to the training information on your website. (https://www.example.com/)</div>
                                    </v-tooltip>
                                </v-text-field>
                            </template>
                        </div>
                        <v-alert class="pa-2 mt-6" :value="$v.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
                            <span class="caption">Please fill out form correctly</span>
                        </v-alert>
                        <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert"
                                 transition="scale-transition">
                            <span class="caption">{{ serverValidationMessage }}</span>
                        </v-alert>
                    </div>
                </v-card-text>

                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
                    <v-btn
                            color="primary"
                            :disabled="loadingSave"
                            :loading="loadingSave"
                            @click="EditTraining"
                    >Save
                    </v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
    import ApiService from "@/common/api.service"
    import { validationMixin } from "vuelidate"
    import { required, email, url } from "vuelidate/lib/validators"
    import { valMessages, getValMessage } from "@/common/error-messages"

    let validations = {}

    export default {
        name: 'EditTraining',
        mixins: [validationMixin],
        validations() {
            validations = {
                preparedData: {
                    category_ids: { required },
                    title: { required },
                    description: { required },
                    contact_email: { required, email },
                    contact_phone: { required },
                    date_to: { required },
                    date_from: { required }
                }
            }

            if(this.preparedData.not_have_location) {
                validations.preparedData.website = { required, url }
            } else {
                validations.preparedData.city = { required }
                validations.preparedData.address = { required }
                validations.preparedData.state_id = { required }
                validations.preparedData.country_id = { required }
            }

            this.errors = getValMessage(valMessages)(validations);
            return validations;
        },
        data: () => ({
            no_data: [null, "", undefined, "null"],
            item: null,
            menu1: false,
            menu2: false,
            preparedData: {},
            trainingCategories: [],
            states: [],
            countries: [],
            loading: false,
            loadingSave: false,
            loadingTrainingCategories: false,
            loadingStates: false,
            loadingTraining: false,
            dialog: false,
            serverValidation: true,
            serverValidationMessage: "Oops something went wrong...",
            server_errors: {}
        }),
        mounted() {
            this.$root.$on('EditTraining', this.openModal)
            this.$root.$on('LoadAndEditTraining', this.loadAndOpenModal)
        },
        beforeDestroy() {
            this.$root.$off('EditTraining', this.openModal)
            this.$root.$off('LoadAndEditTraining', this.loadAndOpenModal)
        },
        methods: {
            getTrainingCategories() {
                this.loadingTrainingCategories = true;
                return new Promise((resolve, reject) => {
                    ApiService.get("/categories/show_training")
                        .then(response => {
                            let data = response.data;
                            this.trainingCategories = data.categories
                            this.loadingTrainingCategories = false;
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.loadingTrainingCategories = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            getStates() {
                this.loadingStates = true;
                return new Promise((resolve, reject) => {
                    ApiService.get("/states")
                        .then(response => {
                            let data = response.data;
                            this.states = data.states
                            this.loadingStates = false;
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.loadingStates = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            getCountries() {
                return new Promise((resolve, reject) => {
                    ApiService.get("/countries")
                        .then(response => {
                            let data = response.data;
                            this.countries = data.countries
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            loadTraining(id) {
                this.loadingTraining = true;
                return new Promise((resolve, reject) => {
                    ApiService.get(`/admin/training/${id}/show`, {organization_id: this.$route.params.organization_id})
                        .then(response => {
                            let data = response.data;
                            this.preparedData = {
                                ...data.training,
                                category_ids: data.training_topics.map(i => i.id)
                            }
                            this.preparedData.country_id = Number(this.preparedData.country_id)
                            this.preparedData.state_id = Number(this.preparedData.state_id)
                            this.loadingTraining = false
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.loadingTraining = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            openModal(inputData) {
                this.resetServerValidation()
                this.preparedData = inputData
                this.preparedData.country_id = Number(this.preparedData.country_id)
                this.preparedData.state_id = Number(this.preparedData.state_id)
                this.file = null
                this.loading = true
                this.$v.$reset()
                this.dialog = true
                Promise.all([this.getStates(), this.getCountries(), this.getTrainingCategories()])
                    .then(values => {
                        this.loading = false
                    })
                    .catch(error => {
                        this.resetServerValidation();
                        this.loading = false
                    });
            },
            loadAndOpenModal(inputData) {
                this.resetServerValidation()
                this.preparedData = inputData
                this.file = null
                this.loading = true
                this.$v.$reset()
                this.dialog = true
                Promise.all([this.getStates(), this.getTrainingCategories(), this.loadTraining(inputData.id), this.getCountries()])
                    .then(values => {
                        this.loading = false
                    })
                    .catch(error => {
                        this.resetServerValidation();
                        this.loading = false
                    });
            },
            EditTraining() {
                this.resetServerValidation()
                this.$v.preparedData.$touch()
                if (!this.$v.preparedData.$invalid) {
                    this.loadingSave = true
                    let body = _.cloneDeep(this.preparedData)
                    if(!body.not_have_location) {
                        body.state = this.states.find(i => i.id === body.state_id).name
                        if(body.country_id) { body.country = this.countries.find(i => i.id === body.country_id).name } else { body.country_id = null }
                        delete body.website
                    } else {
                        delete body.state
                        delete body.state_id
                        delete body.country
                        delete body.country_id
                    }
                    body.category_ids = [...body.category_ids].join(',')
                    body.organization_id = this.$route.params.organization_id
                    ApiService.put(`/admin/training/${this.preparedData.id}/update`, body)
                        .then(response => {
                            this.$root.$emit("notification", {
                                status: "success",
                                text: `Training has been successfully edited`
                            });
                            this.loadingSave = false
                            this.$emit('done')
                            this.closeModal()
                        })
                        .catch(({response}) => {
                            this.loadingSave = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            if (response.data.message) {
                                this.serverValidationMessage = response.data.message;
                            }
                            if (response.data.errors) {
                                this.server_errors = response.data.errors;
                            }
                        });
                }
            },
            closeModal() {
                this.dialog = false
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, " "));
            },
            checkState () {
                if(this.preparedData.country_id && this.preparedData.state_id) {
                    if(this.states.find(i => i.id === this.preparedData.state_id).country_id !== this.preparedData.country_id) {
                        this.preparedData.state_id = null
                    }
                }
            },
            errors: getValMessage(valMessages)(validations),
            resetServerValidation() {
                this.serverValidation = true;
                this.serverValidationMessage = "Oops something went wrong...";
                this.server_errors = {};
            },
        },
        computed: {
            filteredStates: function () {
                return this.states.filter(i => {
                    if(this.preparedData.country_id) { return Number(i.country_id) === Number(this.preparedData.country_id) }
                    else { return true }
                })
            }
        }
    }
</script>
